module.exports = __webpack_public_path__ + "static/media/outpatient_claims_hor.ba869e35.png";